// extracted by mini-css-extract-plugin
module.exports = {"resources":"resources-module--resources--32bz5"};